import React from 'react';
import {
    Paper,
    Grid,
    Typography,
} from '@mui/material';
import NoReportSelectedIcon from '../../Icons/no_report_selected.svg';
import { trakrefFontFamily, trakrefFontFamilySemiBold } from '../../utils';
import PropTypes from 'prop-types';

const Placeholder = ({
    message,
    subMessage,
    children
}) => (
    <Grid container component={Paper} direction="column">
        <Grid item xs={12} lg={12} align='center'>
            <img
                style={{ paddingTop: '2%' }}
                src={NoReportSelectedIcon}
            />
        </Grid>
        <Grid item xs={12} lg={12}>
            <Typography
                variant='h5'
                align='center'
                sx={{
                    marginTop: '2%',
                    paddingBottom: '2%',
                    color: '#1A173B',
                    fontSize: '20px',
                    fontFamily: trakrefFontFamilySemiBold,
                }}
            >
                {message}
            </Typography>
        </Grid>
        <Grid item xs={12} lg={12} sx={{ paddingBottom: '3%' }}>
            <Typography
                variant='h5'
                align='center'
                sx={{
                    marginTop: '2%',
                    paddingBottom: '2%',
                    color: '#1A173B',
                    fontSize: '14px',
                    fontFamily: trakrefFontFamily,
                }}
            >
                {subMessage}
            </Typography>
        </Grid>
        {children && children}
    </Grid>
);

Placeholder.propTypes = {
    message: PropTypes.string,
    subMessage: PropTypes.string,
    children: PropTypes.node,
};

Placeholder.defaultProps = {
    message: "Oops... It is empty here...",
    subMessage: "Please select a report from the left menu.",
};

export default Placeholder;
